import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { Contest } from '@/domain/entities/problem/contest'
import { Course } from '@/domain/entities/problem/course'
import { ProblemSearchModalStateType } from '@/domain/value_objects/problem/problemModalStateType'
import { ProblemSearchModalStateModuleName } from '@/store/modules/modules'

export class ProblemSearchModalStateViewModel {
  private store = useStore()

  modalState: ComputedRef<ProblemSearchModalStateType> = computed(
    () => this.store.getters[`${ProblemSearchModalStateModuleName}/modalState`]
  )

  selectedCourse: ComputedRef<Course> = computed(
    () => this.store.getters[`${ProblemSearchModalStateModuleName}/selectedCourse`]
  )

  selectedContestList: ComputedRef<Contest[]> = computed(
    () => this.store.getters[`${ProblemSearchModalStateModuleName}/selectedContestList`]
  )

  setModalState(modalState: ProblemSearchModalStateType): void {
    this.store.commit(`${ProblemSearchModalStateModuleName}/setModalState`, modalState)
  }

  setSelectedCourse(course: Course): void {
    this.store.commit(`${ProblemSearchModalStateModuleName}/setSelectedCourse`, course)
  }

  setSelectedContestList(contest: Contest[]): void {
    this.store.commit(`${ProblemSearchModalStateModuleName}/setSelectedContestList`, contest)
  }
}
